<template>
    <div class="m-cont">
        <div class="nav-sale">
            <div class="con-sal">
                <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
            </div>
            TRADUZIONE MENU
        </div>

        <div class="content-form-map">
            <div class="main-tab">
                <h5>Filtri e Opzioni</h5>
                <div class="filters">
                    <input type="text" v-model="searchQuery" placeholder="Cerca piatti o prodotti..." class="filter-input-cli">
                    
                    <div class="lang-selector">
                        <p>Lingue di destinazione:</p>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="it" value="it" v-model="selectedLangs">
                            <label class="form-check-label" for="it">Italiano (it)</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="en" value="en" v-model="selectedLangs">
                            <label class="form-check-label" for="en">Inglese (en)</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="es" value="es" v-model="selectedLangs">
                            <label class="form-check-label" for="es">Spagnolo (es)</label>
                        </div>
                    </div>

                    <div class="actions mt-3">
                        <button class="btn btn-primary w-100" @click="startTranslation" :disabled="isTranslating || selectedItems.length === 0">
                            {{ isTranslating ? 'Traduzione in corso...' : 'Traduci Selezionati (' + selectedItems.length + ')' }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="main-map">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5>Elenco Elementi</h5>
                    <div class="select-actions">
                        <button class="btn btn-outline-secondary btn-sm me-2" @click="selectAll">Seleziona Tutti</button>
                        <button class="btn btn-outline-secondary btn-sm" @click="deselectAll">Deseleziona Tutti</button>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table table-hover border">
                        <thead class="table-light">
                            <tr>
                                <th width="40"><input type="checkbox" @change="toggleAll($event)" :checked="isAllSelected"></th>
                                <th>Tipo</th>
                                <th>Nome (IT)</th>
                                <th>Traduzioni Existenti</th>
                                <th>Descrizione</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in filteredItems" :key="item.id">
                                <td><input type="checkbox" :value="item.id" v-model="selectedItems"></td>
                                <td><span class="badge" :class="item.type === 'Piatto' ? 'bg-info' : 'bg-secondary'">{{ item.type }}</span></td>
                                <td>
                                    <strong>{{ item.nome }}</strong>
                                    <span v-if="item.portata" class="badge bg-light text-dark ms-2">{{ item.portata }}</span>
                                    <div class="small text-muted" v-if="item.nomeEn || item.nomeEs">
                                        <span v-if="item.nomeEn">EN: {{ item.nomeEn }} </span>
                                        <span v-if="item.nomeEs">ES: {{ item.nomeEs }}</span>
                                    </div>
                                </td>
                                <td>
                                    <span :class="item.nomeEn ? 'text-success' : 'text-danger'">EN</span> | 
                                    <span :class="item.nomeEs ? 'text-success' : 'text-danger'">ES</span>
                                </td>
                                <td class="small">{{ item.descrizione || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { store } from '../store/store.js'

export default {
    name: 'Traduci',
    data() {
        return {
            items: [],
            selectedItems: [],
            selectedLangs: ['it', 'en', 'es'],
            searchQuery: '',
            isTranslating: false,
            store
        }
    },
    computed: {
        filteredItems() {
            if (!this.searchQuery) return this.items;
            const q = this.searchQuery.toLowerCase();
            return this.items.filter(item => 
                (item.nome && item.nome.toLowerCase().includes(q)) || 
                (item.descrizione && item.descrizione.toLowerCase().includes(q))
            );
        },
        isAllSelected() {
            return this.filteredItems.length > 0 && this.selectedItems.length === this.filteredItems.length;
        }
    },
    methods: {
        home() {
            this.$router.push({ name: "Gestionale" })
        },
        async fetchData() {
            try {
                const config = {
                    headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
                };

                // Fetch Menu (Piatti)
                const menuRes = await this.axios.post(this.store.path + 'displayMenu', config);
                const piatti = (menuRes.data.messaggio || []).map(p => ({
                    id: p.id,
                    nome: p.nome,
                    nomeEn: p.nomeEn,
                    nomeEs: p.nomeEs,
                    descrizione: p.descrizione,
                    portata: p.portata,
                    type: 'Piatto'
                }));

                // Fetch Products (Mapps)
                const prodRes = await this.axios.post(this.store.path + 'displayProduct', config);
                const prodotti = (prodRes.data.messaggio || []).map(p => ({
                    id: p.code || p.nome,
                    nome: p.nome || p.descrizio,
                    nomeEn: p.nomeEn,
                    nomeEs: p.nomeEs,
                    descrizione: p.descrizio,
                    type: 'Prodotto'
                }));

                this.items = [...piatti, ...prodotti];
            } catch (error) {
                console.error("Errore caricamento dati:", error);
            }
        },
        toggleAll(e) {
            if (e.target.checked) {
                this.selectedItems = this.filteredItems.map(i => i.id);
            } else {
                this.selectedItems = [];
            }
        },
        selectAll() {
            this.selectedItems = this.filteredItems.map(i => i.id);
        },
        deselectAll() {
            this.selectedItems = [];
        },
        async startTranslation() {
            if (this.selectedItems.length === 0) return;
            
            this.isTranslating = true;
            try {
                const itemsToTranslate = this.items.filter(i => this.selectedItems.includes(i.id));
                
                const response = await this.axios.post(this.store.path + 'translate', {
                    items: itemsToTranslate,
                    languages: this.selectedLangs
                }, {
                    headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
                });

                alert(response.data.messaggio);
                await this.fetchData(); // Ricarica dati aggiornati
                this.selectedItems = [];
            } catch (error) {
                console.error("Errore traduzione:", error);
                alert("Si è verificato un errore durante la traduzione.");
            } finally {
                this.isTranslating = false;
            }
        }
    },
    mounted() {
        this.fetchData();
    }
}
</script>

<style scoped>
.m-cont {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #f8f9fa;
    padding-bottom: 50px;
}

.nav-sale {
    padding: 15px;
    background: #343a40;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    font-weight: bold;
    font-size: 1.2rem;
}

.content-form-map {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 20px;
}

.main-tab {
    flex: 1;
    min-width: 300px;
    max-width: 400px;
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.main-map {
    flex: 3;
    min-width: 500px;
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.lang-selector {
    background: #f1f3f5;
    padding: 15px;
    border-radius: 8px;
    margin-top: 15px;
}

.lang-selector p {
    font-weight: bold;
    margin-bottom: 10px;
}

.filter-input-cli {
    width: 100%;
    padding: 10px;
    border: 1px solid #ced4da;
    border-radius: 6px;
    margin-bottom: 15px;
}

.table th {
    background: #f8f9fa;
    color: #495057;
    font-weight: 600;
}

.badge {
    font-weight: 500;
}

@media (max-width: 992px) {
    .content-form-map {
        flex-direction: column;
    }
    .main-tab {
        max-width: 100%;
    }
}
</style>
